module.exports = __webpack_public_path__ + "9983ee3e86d4e090992db640a3615ba4.svg";